<template>
    <div>
        <vbl-breadcrumb>
            <vbl-breadcrumb-item to="/">首页</vbl-breadcrumb-item>
            <vbl-breadcrumb-item to="/detail">详情页</vbl-breadcrumb-item>
            <vbl-breadcrumb-item>编辑</vbl-breadcrumb-item>
        </vbl-breadcrumb>
    </div>
</template>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// vblBreadcrumbExample.vue?1e480cd1